import { render, staticRenderFns } from "./vehicle-apps-overview.vue?vue&type=template&id=0a4dbbdc"
import script from "./vehicle-apps-overview.vue?vue&type=script&lang=js"
export * from "./vehicle-apps-overview.vue?vue&type=script&lang=js"
import style0 from "./vehicle-apps-overview.vue?vue&type=style&index=0&id=0a4dbbdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports